import * as React from "react";
import LoginPopup from "../generic/loginPopup";
// import DeviceContext from "../../components/service/indentifyDevice";
import DeviceContext from "../../../services/indentifyDevice";

import Loader from "../../generic/loader";
import "../../../assets/scss/Login/login/loginScreen/loginLoaderScreen.scss";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface ILoginLoaderScreenProps {}

const LoginLoaderScreen: React.FC<ILoginLoaderScreenProps> = (props) => {
  return (
    <LoginPopup
      leftHeaderContent={
        !DeviceContext().isDesktop ? (
          <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
        ) : undefined
      }
      centerHeaderContent={
        DeviceContext().isDesktop ? (
          <span className="edel-icon-edel-logo1 logo1" />
        ) : undefined
      }
      className="change_pw_scrn"
    >
      <div className="login_loader_wrap">
        <Loader size={100} color="blue" />
      </div>
    </LoginPopup>
  );
};

export default LoginLoaderScreen;
